module.exports = __webpack_public_path__ + "static/media/complexPic9.7763f36e.png";